
import axios from 'axios';
import { handleSignout } from './Logout';


const BASE_URL = process.env.REACT_APP_BASEURL;

export const Generateqr = async (endpoint = 'encrypt-param', method = 'POST', data = null, headers = {}) => {

  try {
    const response = await axios({
      url: `${BASE_URL}${endpoint}`,
      method,
      data,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      withCredentials: true,

    });

    return response?.data;
  } catch (error) {
    console.error('API Error:', error?.response?.data?.message || error);
    if (error?.response?.status === 401) {
      handleSignout();

    }
    throw error;
  }
};
